module.exports = __webpack_public_path__ + "static/img/puzzle.bb8e648.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/puzzle.jpg
// module id = u30J
// module chunks = 8